(function () {
  'use strict';

  angular
    .module('deadHeadingReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('deadHeadingReport', {
        url: '/dead-heading-report',
        views : {
        	'deadHeadingReportView' : {
        		templateUrl: 'dead-heading-report/views/dead-heading-report.tpl.html',
                controller: 'DeadHeadingReportCtrl',
                controllerAs: 'deadHeadingReport'
        	}
        }
      });
  }
}());
